import type { CpsPolicies, CpsPolicy } from '../store/complianceStore.types';

/**
 * Individual policy payload from CPS API response.
 */
export interface CpsPoliciesPayload {
  readonly settingId: string;
  readonly value: string;
}

/**
 * Policy response value containing priority and payload.
 */
export interface CpsPolicyResponseValue {
  readonly priority: number;
  readonly policiesPayload: CpsPoliciesPayload[];
}

/**
 * Raw CPS API response structure.
 */
export interface CpsPolicyApiResponse {
  readonly policiesHash: string;
  readonly value: CpsPolicyResponseValue[] | null;
}

/**
 * Processed CPS policy response with extracted check-in time.
 */
export interface CpsPolicyResponse {
  readonly policiesHash: string;
  readonly policies: CpsPolicies;
  readonly checkInTime: string;
}

/**
 * CPS policy setting IDs as returned by the API.
 */
export const CpsPolicySettingIds = {
  SendFeedback: 'office16;L_SendFeedback',
  SendSurvey: 'office16;L_SendSurvey',
  ConnectedExperiences: 'office16;L_ConnectedOfficeExperiences',
  Screenshot: 'office16;L_Screenshot',
  LogCollection: 'office16;L_LogCollection',
  EmailCollection: 'office16;L_EmailCollection',
} as const;

/**
 * Map from CPS setting IDs to internal policy names.
 */
export const CpsPolicySettingMap: Record<string, CpsPolicy> = {
  [CpsPolicySettingIds.SendFeedback]: 'UserFeedbackFormEnabled',
  [CpsPolicySettingIds.SendSurvey]: 'SurveyFeedbackFormEnabled',
  [CpsPolicySettingIds.ConnectedExperiences]: 'ConnectedExperiencesEnabled',
  [CpsPolicySettingIds.Screenshot]: 'AllowScreenshots',
  [CpsPolicySettingIds.LogCollection]: 'AllowLogCollection',
  [CpsPolicySettingIds.EmailCollection]: 'AllowEmailCollection',
};

/**
 * Value indicating a policy is enabled in CPS response.
 */
export const cpsPolicyEnabledValue = '1';
